import { withViewModel } from '../../../../../infrastructure/components/with-view-model';
import { ConnectionTemplatesFormVM } from '../connection-template-form.viewmodel';
import ConnectionTemplatePodiumPresentation from './connection-template-podium.presentation';

interface IConnectionTemplatePodiumSectionProps {
    vm: ConnectionTemplatesFormVM;
};

const ConnectionTemplatePodiumSection = withViewModel(
    ConnectionTemplatePodiumPresentation,
    (props: IConnectionTemplatePodiumSectionProps) => {
        return props.vm;
    }
);

export default ConnectionTemplatePodiumSection;
